import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "split"
})
export class SplitPipe implements PipeTransform {
  transform(val: string, params: string[]): string {
    if (val === '') {
      return val;
    }
    let arrayData = val.split(";");
    let valReturn = '';
    try {
      valReturn = arrayData[Number(params[0])];
    } catch (error) {
      console.log(error);
      valReturn = '';
    }
    return valReturn;
  }
}
